import { Injectable } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { getDefaultControlValue } from '@gk/gk-modules';
import { ECSControlName } from '../../../../components/electronic-correspondence-statement/models/form/form.model';
import { BaseNewRequestFormService } from '../../../../shared/base-new-request-form/base-new-request-form.service';
import { DocumentationFormType } from '../../../../shared/base-new-request/base-new-request.model';
import {
  ATIOEAIPNewRequestControlName,
  ATIOEAIPNewRequestFormGroup,
} from './new-request-form.model';

@Injectable()
export class ATIOEAIPNewRequestFormService {
  constructor(
    private formBuilder: UntypedFormBuilder,
    private baseNewRequestFormService: BaseNewRequestFormService,
  ) {}

  getFormGroup(): FormGroup<ATIOEAIPNewRequestFormGroup> {
    return this.formBuilder.group({
      ...this.baseNewRequestFormService.getCommonApplicantFormGroup(
        {
          [ATIOEAIPNewRequestControlName.ProxyDetailsCheckbox]: false,
          [ECSControlName.ElectronicCorrespondenceStatement]: false,
        },
        {
          documentationFormType: DocumentationFormType.NonElectronicForm,
        },
      ).controls,
      [ATIOEAIPNewRequestControlName.DetailedScope]: [
        getDefaultControlValue(),
        [Validators.required],
      ],
      [ATIOEAIPNewRequestControlName.AdditionalIndications]: [
        getDefaultControlValue(),
      ],
    });
  }
}
